import { INVOICE_PAYMENT_STATUS } from '~constants/invoice';
import { OfflinePaymentMethodsValues } from '~constants/payments';

export enum offlinePaymentMethods {
	CHECK = 'CHECK',
	CASH = 'CASH',
	ACH = 'ACH',
	CREDIT_CARD = 'CREDIT_CARD',
}

export const offlinePaymentMethodValues: {
	[K in offlinePaymentMethods]: OfflinePaymentMethodsValues;
} = {
	[offlinePaymentMethods.CHECK]: OfflinePaymentMethodsValues.CHECK,
	[offlinePaymentMethods.CASH]: OfflinePaymentMethodsValues.CASH,
	[offlinePaymentMethods.ACH]: OfflinePaymentMethodsValues.ACH,
	[offlinePaymentMethods.CREDIT_CARD]: OfflinePaymentMethodsValues.CREDIT_CARD,
};

export const offlinePaymentMethodsLabels = {
	[offlinePaymentMethods.CHECK]: 'Check',
	[offlinePaymentMethods.CASH]: 'Cash',
	[offlinePaymentMethods.ACH]: 'ACH',
	[offlinePaymentMethods.CREDIT_CARD]: 'Credit Card',
};

export const addNewInvoiceWizardSteps = {
	customer: 'customer',
	orders: 'orders',
	terms: 'terms',
};

export const INVOICE_PAYMENT_TYPES = {
	ONLINE: 'ONLINE',
	OFFLINE: 'OFFLINE',
};

export const INVOICE_PAYMENT_WIZARD_STEPS = {
	CHOOSE: 'CHOOSE',
	...INVOICE_PAYMENT_TYPES,
};

export const INVOICE_STATUSES = {
	UNPAID: 'UNPAID',
	PAID: 'PAID',
};

export const TABS = [
	{ label: 'Unpaid', value: INVOICE_PAYMENT_STATUS.UNPAID },
	{ label: 'Paid', value: INVOICE_PAYMENT_STATUS.PAID },
];

/**
 * Predefined fixed settings values for Payment Due Terms
 */
export enum PaymentDueTermsFromSettings {
	DUE_ON_RECEIPT = 'DUE_ON_RECEIPT',
	NET15 = 'NET15',
	NET30 = 'NET30',
	NET45 = 'NET45',
	NET60 = 'NET60',
}

/**
 * Customizable values for Payment Due Terms
 */
export enum PaymentDueTermsCustomizable {
	CUSTOM_DATE = 'CUSTOM_DATE',
}

/**
 * All possible values for Payment Due Terms
 */
export type PaymentDueTermsAll =
	| PaymentDueTermsFromSettings
	| PaymentDueTermsCustomizable;
export const PaymentDueTermsAll = {
	...PaymentDueTermsFromSettings,
	...PaymentDueTermsCustomizable,
};

/**
 * Labels for all possible values for Payment Due Terms
 */
export const PAYMENT_DUE_TERMS_LABELS: {
	[K in PaymentDueTermsAll]: string;
} = {
	[PaymentDueTermsAll.DUE_ON_RECEIPT]: 'Due on receipt',
	[PaymentDueTermsAll.NET15]: 'Net 15',
	[PaymentDueTermsAll.NET30]: 'Net 30',
	[PaymentDueTermsAll.NET45]: 'Net 45',
	[PaymentDueTermsAll.NET60]: 'Net 60',
	[PaymentDueTermsAll.CUSTOM_DATE]: 'Custom due date',
};

/**
 * @deprecated - Use `PAYMENT_DUE_TERMS_LABELS` instead
 */
export const PAYMENT_DUE_TERMS = PAYMENT_DUE_TERMS_LABELS;

export const INVOICE_PAYMENT_METHODS = {
	CARD: 'CARD',
	US_BANK_ACCOUNT: 'ACH',
};

export const INVOICE_PAYMENT_STATUSES = {
	UNPAID: 'UNPAID',
	PAID: 'PAID',
	PENDING: 'PENDING',
};

export const INVOICE_PAYMENT_SOURCE_APP = {
	BUSINESS_MANAGER: 'BUSINESS_MANAGER',
	COMMERCIAL_CLIENT: 'COMMERCIAL_CLIENT_INVOICE_VIEW',
};
